import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { DocumentTemplate } from "../../lib/interfaces/DocumentTemplate";
import {
  fetchDocumentTemplateVerionsRoute,
  searchDocumentTemplatesRoute,
} from "../../lib/routes/documentTemplates";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { LoadingStatusCode } from "../../lib/types";

export interface IDocumentTemplates {
  templates: DocumentTemplate[];
  templatesLoading: LoadingStatusCode;
  templateVersions: DocumentTemplate[];
  templateVersionsLoading: LoadingStatusCode;
}

const initialState: IDocumentTemplates = {
  templates: [],
  templatesLoading: loadingStatusCodes.idle,
  templateVersions: [],
  templateVersionsLoading: loadingStatusCodes.idle,
};

export const fetchDocumentTemplates = createAsyncThunk(
  "documentTemplates/fetchDocumentTemplates",
  async ({ onDate, reportTypeId }: { onDate?: string; reportTypeId?: number }) => {
    const response = axios.get(searchDocumentTemplatesRoute({ onDate, reportTypeId }));
    const { data }: { data: DocumentTemplate[] } = await response;
    return data;
  }
);

export const fetchDocumentTemplateVersions = createAsyncThunk(
  "documentTemplates/fetchDocumentTemplateVersions",
  async (reportId: number) => {
    const response = axios.get(fetchDocumentTemplateVerionsRoute(reportId));
    const { data }: { data: DocumentTemplate[] } = await response;
    return data;
  }
);

export const documentTemplatesSlice = createSlice({
  name: "documentTemplates",
  initialState,
  reducers: {
    cleanTemplateVersions: (state) => {
      state.templateVersions = [];
      state.templateVersionsLoading = loadingStatusCodes.idle;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentTemplates.pending, (state) => {
        state.templatesLoading = loadingStatusCodes.pending;
      })
      .addCase(fetchDocumentTemplates.fulfilled, (state, { payload }) => {
        state.templatesLoading = loadingStatusCodes.fulfilled;
        state.templates = payload;
      })
      .addCase(fetchDocumentTemplates.rejected, (state) => {
        state.templatesLoading = loadingStatusCodes.rejected;
      })
      .addCase(fetchDocumentTemplateVersions.pending, (state) => {
        state.templateVersionsLoading = loadingStatusCodes.pending;
      })
      .addCase(fetchDocumentTemplateVersions.fulfilled, (state, { payload }) => {
        state.templateVersions = payload;
        state.templateVersionsLoading = loadingStatusCodes.fulfilled;
      })
      .addCase(fetchDocumentTemplateVersions.rejected, (state) => {
        state.templateVersionsLoading = loadingStatusCodes.rejected;
      });
  },
});

const { reducer, actions } = documentTemplatesSlice;
const { cleanTemplateVersions } = actions;

export { reducer, cleanTemplateVersions };
